import { render, staticRenderFns } from "./PhuTopbar.vue?vue&type=template&id=3bd355d5&scoped=true"
import script from "./PhuTopbar.vue?vue&type=script&lang=js"
export * from "./PhuTopbar.vue?vue&type=script&lang=js"
import style0 from "./PhuTopbar.vue?vue&type=style&index=0&id=3bd355d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd355d5",
  null
  
)

export default component.exports